<template>
  <div
    v-if="isVisible"
    class="overlay"
    @click="dismissPopup"
  >
    <div class="popup">
      <div class="message">
        <slot />
      </div>
      <div class="close-button-container">
        <button
          class="primary"
          @click.stop="closePopup"
        >
          {{ closeButtonText }}
        </button>
        <button
          v-if="bottomLinkText"
          type="button"
          class="popup-bottom-link secondary"
          @click.stop="bottomLinkHandler"
        >
          {{ bottomLinkText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent} from "vue";
import {useI18n} from "vue-i18n";

export default defineComponent({
  name: "HighlightPopup",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    buttonText: {
      type: String,
      default: null
    },
    bottomLinkText: {
      type: String,
      default: ""
    },
  },
  emits: ["close-popup", "dismiss-popup", "bottom-link-click"],
  setup(props) {
    const {t} = useI18n();

    const closeButtonText = computed(
        () => props.buttonText ?? t("HighLight-ButtonText")
    );

    return {
      t,
      closeButtonText
    };
  },
  methods: {
    closePopup() {
      this.$emit("close-popup");
    },
    dismissPopup() {
      this.$emit("dismiss-popup");
    },
    bottomLinkHandler() {
      this.$emit("bottom-link-click");
    }
  },
});
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.popup {
  width: 100%;
  background: white;
  border-radius: 10px 10px 0 0;
  animation: slideUp 0.3s ease-out;
  position: relative;
}

.close-button-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: var(--Gray-elements-Background-BLOCKS);
  padding-bottom: 50px;
  padding-left: 0;
  padding-right: 0;
  margin: 12px;
  gap: 12px;
}

.message {
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@media (max-width: 350px) {
  .close-button {
    min-width: 85%;
  }
}
</style>
